<template>
  <div>
    <div class="sayfahead">
      <h1>{{SayfaAdi}}</h1>
      <el-button-group class="float-right">
        <router-link v-if="this.$store.getters.Yetki.muhasebe>0 && Cari_id"
                     class="el-button YeniBtn el-button--success el-button--small" :to="'/muhasebe/cari/'+Cari_id">Cari
          Ekranı
        </router-link>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-row :gutter="24">
        <el-col :span="4">
          <CariListe @Cari_id="CariGetir($event)" :Yenile="Yenile"></CariListe>
        </el-col>
        <el-col :span="20">
          <el-row :gutter="24" v-if="Cari_id">
            <el-col :span="19">
              <CariEkstre :data="Ekstre" v-if="Ekstre" :Yenile="Yenile"></CariEkstre>
            </el-col>
            <el-col :span="5">
              <div class="SecimKutu mb-3">
                <el-row :gutter="24">
                  <el-form v-if="Form" :rules="FormHata" :model="Form"
                           @submit.prevent.native="Submit"
                           ref="Form">
                    <el-col :span="24">
                      <el-form-item label="Kasa" prop="Kasa_id">
                        <el-cascader
                          collapse-tags
                          :props="{ multiple: false}"
                          :options="Kasalar"
                          v-model="Form.Kasa_id"
                          filterable></el-cascader>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="Tutar" prop="Tutar">
                        <el-input v-model="Form.Tutar"/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="Ödeme Tarihi" prop="oTarihi">
                        <el-date-picker
                          v-model="Form.oTarihi"
                          type="date"
                          placeholder=""
                          format="dd.MM.yyyy">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item label="Açıklama" prop="Aciklama">
                        <el-input v-model="Form.Aciklama"/>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item class="text-center" label="Ödeme Türü" prop="oTarihi">
                        <el-radio-group v-model="Form.Tur" size="mini">
                          <el-radio-button :label="3">Yapılan</el-radio-button>
                          <el-radio-button :label="4">Alınan</el-radio-button>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-form>
                  <el-col :span="24">
                    <el-button v-if="!lo" class="btn-block" @click="MakbuzUret" size="small"
                               type="success"> Ödemeyi Onayla
                    </el-button>
                  </el-col>
                </el-row>
              </div>
              <div class="BlokSabit scrollkaydir" style="height: 18vh">
              <BilgiKutu :data="BilgiKutu" v-if="BilgiKutu"></BilgiKutu>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <MakbuzDetay v-if="MakbuzDetayModal" :mNo="mNo" @MakbuzDetayModal="MakbuzDetayModal=false"
                 :MakbuzDetayModal="MakbuzDetayModal"></MakbuzDetay>
  </div>
</template>

<script>
  import CariListe from "../../components/Pack/Vezne/CariListe";
  import BilgiKutu from "../../components/Pack/Genel/BilgiKutu";
  import MakbuzDetay from "../../components/Pack/Vezne/MakbuzDetay";
  import CariEkstre from "../../components/Pack/Muhasebe/cari/CariEkstre";
  import Yukleniyor from "../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor, CariEkstre, MakbuzDetay, BilgiKutu, CariListe},
    data() {
      return {
        Cari_id: null,
        Ekstre: null,
        DuzenleYetki: null,
        MakbuzDetayModal: false,
        Yenile: false,
        SayfaAdi: 'Ödeme Ekranı',
        Kaydet: false,
        mNo: null,
        lo: false,
        BilgiKutu: null,
        Bina_id: null,
        BinaBilgi: null,
        Kasalar: null,
        AltToplam: {
          Gecikmis: 0,
          Guncel: 0,
          Toplam: 0,
        },
        Form: {
          Kasa_id: null,
          Cari_id: this.Cari_id,
          Bina_id: this.$route.params.Bina_id,
          Tutar: 0,
          oTarihi: null,
          Aciklama: null,
          Tur: 3
        },
        FormHata: {
          Kasa_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Tutar: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          oTarihi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
      }
    },
    methods: {

      ModalKapat() {
        this.SayfaYukle();
        this.Yenile = true;
      },
      CariGetir(event) {
        this.Cari_id = event;
      },
      MakbuzUret() {

        this.$refs['Form'].validate((valid) => {
          if (valid) {
            this.lo = true
            this.$store.dispatch("Post", {...this.Form, path: 'muhasebe/odeme'})
              .then(response => {
                if (response.Durum == "OK") {
                  this.MakbuzDetayModal = true;
                  this.SayfaYukle();
                  this.mNo = response.mNo;
                  this.Yenile = true;
                  this.lo = false;
                } else {
                  this.lo = false;
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }
        })
      },
      Sifirla() {
        this.Form = {
          Kasa_id: null,
          Cari_id: this.Cari_id,
          Bina_id: this.$route.params.Bina_id,
          Tutar: 0,
          oTarihi: null,
          Aciklama: null,
          Tur: 3
        }
      },
      SayfaYukle() {
        if (this.Cari_id) {

          this.$store.dispatch("Get", {path: 'muhasebe/kasa/' + this.Bina_id})
            .then(response => {
              if (response.Durum === 'OK') {
                this.Kasalar = response.Liste
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            });

          this.Sifirla();
          this.$store.dispatch("Get", {path: 'muhasebe/cari/d/' + this.Cari_id})
            .then(response => {
              if (response.Durum === 'OK') {
                this.Yenile = false;
                this.Bilgi = response.Bilgi;
                this.SayfaAdi = response.Bilgi.Unvan;
                this.BilgiKutu = {
                  Baslik: 'Cari Bilgi',
                  Detay: [
                    {Baslik: 'Ticari Ünvan', Bilgi: this.Bilgi.Unvan, Ikon: 'flaticon-background'},
                    {
                      Baslik: 'Vergi Dairesi / Vergi No. ',
                      Bilgi: this.Bilgi.vDairesi + ' / ' + this.Bilgi.vNo,
                      Ikon: 'flaticon-background'
                    },
                    {Baslik: 'Telefon', Bilgi: this.Bilgi.Telefon, Ikon: 'flaticon-background'},
                    {Baslik: 'Mail', Bilgi: this.Bilgi.Mail, Ikon: 'flaticon-background'},
                    {Baslik: 'Adres', Bilgi: this.Bilgi.Adres, Ikon: 'flaticon-background'},
                    {
                      Baslik: 'Banka Adı',
                      Bilgi: this.Bilgi.bBilgi.Adi,
                      Ikon: 'flaticon-background'
                    },
                    {Baslik: 'IBAN', Bilgi: this.Bilgi.bBilgi.Iban, Ikon: 'flaticon-background'},
                  ]
                };

              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            });

          // CARİ EKSTRE
          this.Ekstre = {
            Bina_id: this.$route.params.Bina_id,
            Cari_id: this.Cari_id
          };
          var Gun = new Date();
          this.Form.oTarihi = Gun;

        }

      },

    },
    created() {


      if (this.$store.getters.BinaBilgi) {
        this.BinaBilgi = this.$store.getters.BinaBilgi;
        this.Bina_id = this.BinaBilgi.id;
      }

      this.Cari_id = this.$route.params.Cari_id;
      this.Form.Cari_id = this.Cari_id;
      this.Form.Bina_id = this.$route.params.Bina_id;
      this.SayfaYukle();

    },
    computed: {
      KisiSecim() {
        return this.$route.path
      },


    },
    watch: {
      KisiSecim() {
        this.Cari_id = this.$route.params.Cari_id;
        this.ModalKapat();
        //console.log(this.Form.Tutar);
      },

    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Vezne/Odeme.vue